import {
  NJAccordion,
  NJAccordionItem,
  NJAccordionItemContent,
  NJAccordionItemHeader,
  NJSidebarCloseDeprecated as NJSidebarClose,
  NJSidebarDividerDeprecated as NJSidebarDivider,
  NJSidebarItemDeprecated as NJSidebarItem,
  NJSidebarMenuDeprecated as NJSidebarMenu
} from "@engie-group/fluid-design-system-react";
import { Link } from "react-router-dom";
import styles from "./sidebarFooter.module.css";
import { useMediaQuery } from "@genai/browser";
import { ThemeToggle } from "@genai/themes";
import { KnownPermission, usePermissions } from "@genai/permissions";

export const SidebarFooter = ({
  closeSidebar,
  onNavigate,
}: {
  closeSidebar?: () => void;
  onNavigate?: () => void;
}): React.ReactElement => {
  const { allowed: isAdmin } = usePermissions([KnownPermission.ADMIN, KnownPermission.SUPERADMIN]);
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <NJSidebarMenu className={styles["sidebar-footer"]} isFooterNav>
      <NJSidebarDivider className="genai-sidebar-divider" />
      <ThemeToggle />

      {isAdmin ? (
        <NJAccordion>
          <NJAccordionItem open>
            <NJAccordionItemHeader>
              Panneau d'administration
            </NJAccordionItemHeader>
            <NJAccordionItemContent className={styles["accordion-content"]}>
              <Link className={styles["link"]} to="/">
                <NJSidebarItem
                  icon={{
                    name: "chat",
                  }}
                >
                  Discussion
                </NJSidebarItem>
              </Link>
              <Link
                className={styles["link"]}
                to="/admin/assistant"
                onClick={onNavigate}
              >
                <NJSidebarItem className={styles["link-sidebar-item"]}
                  icon={{
                    name: "smart_toy",
                  }}
                >
                  Assistant
                </NJSidebarItem>
              </Link>
              <Link
                className={styles["link"]}
                to="/admin/collection"
                onClick={onNavigate}
              >
                <NJSidebarItem
                  icon={{
                    name: "polyline",
                  }}
                >
                  Collections
                </NJSidebarItem>
              </Link>
              <Link
                className={styles["link"]}
                to="/admin/organization"
                onClick={onNavigate}
              >
                <NJSidebarItem
                  icon={{
                    name: "corporate_fare",
                  }}
                >
                  Organisations
                </NJSidebarItem>
              </Link>
            </NJAccordionItemContent>
          </NJAccordionItem>
        </NJAccordion>

      ) : (
        <></>
      )}
      {isMobile ? (
        <NJSidebarClose onClick={closeSidebar}>Fermer</NJSidebarClose>
      ) : (
        <></>
      )}
    </NJSidebarMenu>
  );
};
